import { z } from 'zod/v4'

export enum PostSortOption {
  Default = 'default',
  FollowerCount = 'follower_count',
  InteractiveCount = 'interactive_count',
  ViewCount = 'view_count',
  LikeCount = 'like_count',
  CommentCount = 'comment_count',
  PublishTime = 'publish_time',
}

export const postOptionSchema = z.enum(PostSortOption)
